import { SharedHistoryScope } from 'mormaii-web-presentation/shared-history'
import type { ViewFactory } from 'wdc-cube-solid'

import { SharedHistoryView } from './v-shared-history'

export function registerViews(rv: typeof ViewFactory.register) {
    rv(SharedHistoryScope, SharedHistoryView)
}

export { SharedHistoryView }
